import { CDN_URL } from "../utils/constants";
import { useSelector, useDispatch } from "react-redux";
import { addItem, removeItem } from "../utils/cartSlice";

const RestroItems = ({ menuInfo }) => {
    const dispatch = useDispatch();
    const cartItems = useSelector((store) => store.cart.items);

    // Get quantity of this item in cart from Redux store
    const getQty = (id) => cartItems.find((i) => i.id === id)?.quantity || 0;

    return (
        <div>
            {menuInfo.map((item) => {
                const qty = getQty(item.id);
                return (
                    <div
                        key={item.id}
                        data-testid="foodItems"
                        className="flex justify-between items-center py-5 border-b border-gray-50 last:border-none gap-4"
                    >
                        {/* Text info */}
                        <div className="flex-1 min-w-0">
                            <h3 className="font-bold text-gray-800 text-sm">{item.name}</h3>
                            <p className="text-orange-500 font-semibold text-sm mt-0.5">₹{item.price}</p>
                            {item.description && (
                                <p className="text-gray-400 text-xs mt-1 line-clamp-2 leading-relaxed">
                                    {item.description}
                                </p>
                            )}
                        </div>
                        {/* Image + Add/counter button */}
                        <div className="relative shrink-0">
                            <img
                                className="w-28 h-20 object-cover rounded-xl"
                                src={CDN_URL + item.cloudinaryImageId}
                                alt={item.name}
                            />
                            {qty === 0 ? (
                                <button
                                    className="absolute -bottom-2.5 left-1/2 -translate-x-1/2 px-6 py-1 bg-white text-green-600 border border-green-500 text-xs font-extrabold rounded-lg shadow hover:bg-green-50 active:scale-95 transition-all whitespace-nowrap"
                                    onClick={() => dispatch(addItem(item))}
                                >
                                    Add +
                                </button>
                            ) : (
                                <div className="absolute -bottom-2.5 left-1/2 -translate-x-1/2 flex items-center bg-white border border-green-500 rounded-lg shadow overflow-hidden">
                                    <button
                                        className="px-2.5 py-1 text-green-600 font-extrabold text-sm hover:bg-green-50 active:scale-95 transition-all"
                                        onClick={() => dispatch(removeItem(item.id))}
                                    >
                                        −
                                    </button>
                                    <span className="px-2 text-green-700 font-extrabold text-xs min-w-[20px] text-center">
                                        {qty}
                                    </span>
                                    <button
                                        className="px-2.5 py-1 text-green-600 font-extrabold text-sm hover:bg-green-50 active:scale-95 transition-all"
                                        onClick={() => dispatch(addItem(item))}
                                    >
                                        +
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
export default RestroItems;
